import type { InventoryItem } from "../types";
import { DECORATION_DEFINITIONS } from "../entities/Decoration";

export class DecorationPanel {
  readonly element: HTMLDialogElement;
  private selected: string | null = null;
  private getItems: () => InventoryItem[];
  private onSelect: (catalogId: string) => void;
  private onClose?: (() => void) | undefined;

  constructor(
    _root: HTMLElement,
    getItems: () => InventoryItem[],
    onSelect: (catalogId: string) => void,
    onClose?: (() => void) | undefined
  ) {
    this.getItems = getItems;
    this.onSelect = onSelect;
    this.onClose = onClose;
    this.element = document.createElement("dialog");
    this.element.className = "seed-drawer deco-drawer";
    this.element.setAttribute("aria-label", "装飾を選ぶ");
    document.body.append(this.element);

    this.element.addEventListener("click", (event) => {
      if (event.target === this.element) this.close();
    });
    this.element.addEventListener("cancel", () => this.close());
  }

  open() {
    this.render();
    if (!this.element.open) this.element.showModal();
  }

  close() {
    if (this.element.open) {
      this.element.close();
      this.onClose?.();
    }
  }

  clearSelection() {
    this.selected = null;
  }

  private render() {
    const items = this.getItems();
    if (items.length === 0) {
      this.element.innerHTML = `<section class="seed-drawer-panel deco-drawer-panel glass-panel"><header><div><small>DECORATION</small><h2>装飾を選ぶ</h2></div><button data-close-deco class="close-button" aria-label="閉じる">×</button></header><p class="deco-empty">購入済みの装飾がありません。<br>ショップで購入してください。</p></section>`;
    } else {
      this.element.innerHTML = `<section class="seed-drawer-panel deco-drawer-panel glass-panel"><header><div><small>DECORATION</small><h2>装飾を選ぶ</h2></div><button data-close-deco class="close-button" aria-label="閉じる">×</button></header><div class="deco-grid">${items.map((item) => {
        const def = DECORATION_DEFINITIONS[item.catalogId as keyof typeof DECORATION_DEFINITIONS];
        const name = def?.displayName ?? item.displayName;
        return `<button class="deco-card ${item.catalogId === this.selected ? "selected" : ""}" data-deco="${item.catalogId}"><span class="deco-icon">${def?.emoji ?? "🪴"}</span><strong>${name}</strong><small>在庫 ${item.quantity}</small></button>`;
      }).join("")}</div><p class="deco-hint">装飾を選択してグリッドをクリックで配置</p></section>`;
    }

    this.element.querySelector("[data-close-deco]")?.addEventListener("click", () => this.close());
    this.element.querySelectorAll<HTMLElement>("[data-deco]").forEach((button) => {
      button.addEventListener("click", () => {
        const id = button.dataset.deco!;
        this.selected = id;
        this.onSelect(id);
        if (this.element.open) this.element.close();
      });
    });
  }
}
